/* global axios */
import ApiClient from './ApiClient';

const idempotencyConfig = payload => {
  const key = payload?.idempotency_key || payload?.idempotencyKey;
  return key ? { headers: { 'Idempotency-Key': key } } : undefined;
};

class LeasesAPI extends ApiClient {
  constructor() {
    super('leases', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  operation(id) {
    return axios.get(`${this.url}/${id}/operation`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  renew(id, payload = {}) {
    return axios.post(`${this.url}/${id}/renew`, payload);
  }

  generateInvoices(id, payload = {}) {
    return axios.post(`${this.url}/${id}/generate_invoices`, payload);
  }

  registerPayment(id, payload = {}) {
    return axios.post(
      `${this.url}/${id}/register_payment`,
      payload,
      idempotencyConfig(payload)
    );
  }

  readjustmentPreview(id, params = {}) {
    return axios.get(`${this.url}/${id}/readjustment_preview`, { params });
  }

  readjust(id, payload = {}) {
    return axios.post(`${this.url}/${id}/readjust`, payload);
  }

  createOwnerPayout(id, payload = {}) {
    return axios.post(
      `${this.url}/${id}/owner_payout`,
      payload,
      idempotencyConfig(payload)
    );
  }

  sweepDefaults(id) {
    return axios.post(`${this.url}/${id}/sweep_defaults`);
  }
}

export default new LeasesAPI();
